import React, { Component } from "react";
import Loader from "react-loader-spinner";
import auth from "../../components/auth";
import BackDrop from "../../components/Backdrop/Backdrop";
import { url } from "../../components/url";
import "./AddBusiness.css";

class AddBusiness extends Component {
  state = {
    comp_name: "",
    reg_name: "",
    type: "Cooperatives",
    line: "",
    date: "",
    sector: "Accomodation and Food Services",
    phone: "",
    email: "",
    house_no: "",
    street: "",
    city: "",
    lga: "Agatu",
    tax_office: "Central Ward",
    taxOffList: [],
    isShowLoader: false,
    displayErrors: false,
    networkLoader: true
  };

  componentDidMount() {
    this.getTaxOffices();
  }

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  setCompName = val => {
    this.setState({ comp_name: val.target.value });
  };

  setRegName = val => {
    this.setState({ reg_name: val.target.value });
  };

  setType = val => {
    this.setState({ type: val.target.value });
  };

  setLine = val => {
    this.setState({ line: val.target.value });
  };

  setDate = val => {
    this.setState({ date: val.target.value });
  };

  setSector = val => {
    this.setState({ sector: val.target.value });
  };

  setPhone = val => {
    this.setState({ phone: val.target.value });
  };

  setEmail = val => {
    this.setState({ email: val.target.value });
  };

  setHouseNo = val => {
    this.setState({ house_no: val.target.value });
  };

  setStreet = val => {
    this.setState({ street: val.target.value });
  };

  setCity = val => {
    this.setState({ city: val.target.value });
  };

  setLGA = val => {
    this.setState({ lga: val.target.value });
  };

  setStation = val => {
    this.setState({ tax_office: val.target.value });
  };

  showLoader = event => {
    event.preventDefault();
    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing
      // alert('not valid')
      this.setState({ displayErrors: true });
      return;
    } else {
      this.setState({ displayErrors: false });
      this.setState({ isShowLoader: true });
      setTimeout(() => {
        this.submitForm();
      }, 1000);
    }
  };

  submitForm = () => {
    let confirm = window.confirm("Are you certain of the details entered?");
    if (confirm === true) {
      this.saveTaxPayerHandler();
    } else {
      this.setState({ isShowLoader: false });
    }
  };

  saveTaxPayerHandler = () => {
    let formData = JSON.stringify({
      name: "addBusiness",
      param: {
        comp_name: this.state.comp_name.toUpperCase(),
        reg_name: this.state.reg_name.toUpperCase(),
        type: this.state.type,
        line: this.state.line.toUpperCase(),
        date: this.state.date,
        sector: this.state.sector,
        phone: this.state.phone,
        email: this.state.email,
        house_no: this.state.house_no,
        street: this.state.street.toUpperCase(),
        city: this.state.city.toUpperCase(),
        lga: this.state.lga,
        tax_office: this.state.tax_office
      }
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        console.log(res);

        if (
          res.hasOwnProperty("response") &&
          res.response.result.response === true
        ) {
          alert("Tax Payer Has Been Successfully Registered!");
          this.props.history.push("/home");
        } else if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          alert(res.response);
        }
      })
      .then(this.setState({ isShowLoader: false }))
      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error + "" === "TypeError: Failed to fetch") {
          alert(
            "Please check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  getTaxOffices = () => {
    let formData = JSON.stringify({
      name: "getTaxOffices",
      param: {}
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);

        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          this.setState({ taxOffList: res, networkLoader: false });
        }
      });
  };

  render() {
    const { displayErrors } = this.state;

    const taxOffice = this.state.taxOffList.map((office, i) => {
      return (
        <option key={i} value={office.station_code}>
          {office.station_code}
        </option>
      );
    });

    let loading = (
      <BackDrop>
        <p>loading...</p>
      </BackDrop>
    );

    return (
      <div>
        {this.state.networkLoader ? loading : null}
        <form
          style={styles.container}
          onSubmit={this.showLoader}
          className={displayErrors ? "displayErrors" : "nodisplayErrors"}
          noValidate
        >
          <input
            type="text"
            placeholder="Company Name"
            onChange={this.setCompName}
            style={styles.input}
            required
          />

          <input
            type="text"
            placeholder="Registered Name"
            onChange={this.setRegName}
            style={styles.input}
            required
          />

          <div style={styles.pickerStyle}>
            <p style={styles.label}>Type of Organization </p>
            <select style={styles.box} onChange={this.setType}>
              <option defaultValue value="Cooperatives">
                Cooperatives
              </option>
              <option value="Enterprise">Enterprise</option>
              <option value="Federal Government">Federal Government</option>
              <option value="Limited Liability Company">
                Limited Liability Company
              </option>
              <option value="Local Government">Local Government</option>
              <option value="Nonprofit Organisation">
                Nonprofit Organisation
              </option>
              <option value="Partnerships">Partnerships</option>
              <option value="Public Liability Company">
                Public Liability Company
              </option>
              <option value="Sole Proprietorship">Sole Proprietorship</option>
              <option value="State Government">State Government</option>
            </select>
          </div>
          <input
            type="text"
            placeholder="Line of Business"
            onChange={this.setLine}
            style={styles.input}
            required
          />
          <div style={styles.pickerStyle}>
            <label style={styles.label} htmlFor="dob">
              Date of Commencement
            </label>

            <input
              id="doc"
              name="doc"
              onChange={this.setDate}
              type="date"
              pattern="\d{2}\/\d{2}/\d{4}"
              data-parse="date"
              style={styles.box}
              required
            />
          </div>
          <div style={styles.pickerStyle}>
            <p style={styles.label}>Sector </p>
            <select style={styles.box} onChange={this.setSector}>
              <option defaultValue value="Accomodation and Food Services">
                Accomodation and Food Services
              </option>
              <option value="Agriculture, Forestry and Fishing">
                Agriculture, Forestry and Fishing
              </option>
              <option value="Arts, Entertainment and Recreation">
                Arts, Entertainment and Recreation
              </option>
              <option value="Construction">Construction</option>
              <option value="Education">Education</option>
              <option value="Electricity, Gas, Steam and Air Conditioning Supply">
                Electricity, Gas, Steam and Air Conditioning Supply
              </option>
              <option value="Financial and Insurance Activities">
                Financial and Insurance Activities
              </option>
              <option value="Human Health and Social Work Activities">
                Human Health and Social Work Activities
              </option>
              <option value="Importation and Exportation">
                Importation and Exportation
              </option>
              <option value="Information and Communication Technology">
                Information and Communication Technology
              </option>
              <option value="Manufacturing">Manufacturing</option>
              <option value="Mining and Quarrying">Mining and Quarrying</option>
              <option value="Other Sectors not elsewhere specified">
                Other Sectors not elsewhere specified
              </option>
              <option value="Professional, Scientific and Technical Activities">
                Professional, Scientific and Technical Activities
              </option>
              <option value="Real Estate Activities">
                Real Estate Activities
              </option>
              <option value="Religious and Non-government Organisation">
                Religious and Non-government Organisation
              </option>
              <option value="Transportation and Storage">
                Transportation and Storage
              </option>
              <option value="Other Service Activities">
                Other Service Activities
              </option>
            </select>
          </div>
          <input
            type="number"
            pattern="\d+"
            placeholder="Phone Number"
            onChange={this.setPhone}
            style={styles.input}
            required
          />
          <input
            type="email"
            placeholder="Email"
            onChange={this.setEmail}
            style={styles.input}
          />
          <input
            type="number"
            pattern="\d+"
            placeholder="House No"
            onChange={this.setHouseNo}
            style={styles.input}
            required
          />
          <input
            type="text"
            placeholder="Street"
            onChange={this.setStreet}
            style={styles.input}
            required
          />

          <input
            type="text"
            placeholder="City"
            onChange={this.setCity}
            style={styles.input}
            required
          />

          <div style={styles.pickerStyle}>
            <p style={styles.label}>LGA of Residence</p>
            <select style={styles.box} onChange={this.setLGA}>
              <option defaultValue value="Agatu">
                Agatu
              </option>
              <option value="Apa">Apa</option>
              <option value="Ado">Ado</option>
              <option value="Buruku">Buruku</option>
              <option value="Gboko">Gboko</option>
              <option value="Guma">Guma</option>
              <option value="Gwer East">Gwer East</option>
              <option value="Gwer West">Gwer West</option>
              <option value="Katsina-Ala">Katsina-Ala</option>
              <option value="Konshisha">Konshisha</option>
              <option value="Kwande">Kwande</option>
              <option value="Logo">Logo</option>
              <option value="Makurdi">Makurdi</option>
              <option value="Obi">Obi</option>
              <option value="Ogbadibo">Ogbadibo</option>
              <option value="Ohimini">Ohimini</option>
              <option value="Oju">Oju</option>
              <option value="Okpokwu">Okpokwu</option>
              <option value="Oturkpo">Oturkpo</option>
              <option value="Tarka">Tarka</option>
              <option value="Ukum">Ukum</option>
              <option value="Ushongo">Ushongo</option>
              <option value="Vandeikya">Vandeikya</option>
            </select>
          </div>

          <div style={styles.pickerStyle}>
            <p style={styles.label}>Tax Office</p>
            <select style={styles.box} onChange={this.setStation}>
              {taxOffice}
            </select>
          </div>

          {this.state.isShowLoader ? (
            <div style={{ alignSelf: "center", marginTop: 10 }}>
              <Loader type="ThreeDots" color="#8cab49" height="40" width="40" />
            </div>
          ) : (
            <button type="submit" style={styles.button}>
              Save
            </button>
          )}
        </form>
      </div>
    );
  }
}

export default AddBusiness;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: 10,
    width: "100%",
    maxWidth: "100%",
    alignContent: "center",
    justifyContent: "center",
    alignSelf: "center",
    backgroundColor: "#eee",
    height: "100%"
  },

  pickerStyle: {
    display: "flex",
    paddingTop: 5,
    width: "90%",
    justifyContent: "space-around",
    alignSelf: "center"
  },

  button: {
    marginTop: 20,
    width: "30%",
    height: "40px",
    backgroundColor: "#8cab49",
    borderColor: "transparent",
    color: "white",
    alignSelf: "center",
    outline: "none"
  },

  input: {
    display: "flex",
    borderStyle: "solid",
    borderRadius: 9,
    marginBottom: 4,
    height: 40,
    backgroundColor: "white",
    textDecorationLine: "none",
    outline: "none",
    paddingLeft: 10,
    width: "90%",
    alignSelf: "center"
  },
  label: {
    paddingTop: 7,
    width: "50%"
  },
  box: {
    height: 50,
    outline: "none",
    width: "50%"
  }
};
